import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useEffect, useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/solid';
import { Client } from '@api/index';
import { Button, RadioButton } from '@pw-tech/omni-ui';
import PowerBatchCalendar from '@assets/images/ambassdor/PowerBatchCalendar';
import PowerBatchPayment from '@assets/images/ambassdor/PowerBatchPayment';


export default function PaymentOptionsModal({ isOpen, onClose, handlePowerPaymentClose, batchDetails, handleInstallmentOpen }: any) {
    const [selected, setSelected] = useState('installments');
    const [partPayment, setPartPayment] = useState<any>({});
    const [fullPayment, setFullPayment] = useState<any>({});

    const getPlanDetails = async (id: string) => {
        const userId = JSON.parse(localStorage.getItem("user") || "{}")?.id || ""
        try {
            if (typeof window !== 'undefined') {
                const response: any = await Client.get(
                    `${process.env.REACT_APP_PP_API_BASE_URL}/v1/student-acquisition/ambassador-client/${id}/plans-list/${userId}`
                )
                return response?.data?.data?.[0]
            }
        } catch (err: any) { }
    }

    useEffect(() => {
        (async () => {
            const planDetails: any = await getPlanDetails(batchDetails?._id)
            setPartPayment(planDetails?.partPayment)
            setFullPayment(planDetails)
        })()
    }, [])

    return (
        <>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-50" onClose={onClose}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-40" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all">

                                    {/* Close Button */}
                                    <button
                                        onClick={onClose}
                                        className="absolute top-4 right-4 text-gray-500 hover:text-black"
                                    >
                                        <XMarkIcon className="h-6 w-6" />
                                    </button>

                                    <Dialog.Title className="text-xl font-semibold mb-4">
                                        Select a Payment Option
                                    </Dialog.Title>

                                    <div className="mb-6">
                                        <p className="text-[#757575] text-sm font-medium mb-3">Suggested Method</p>
                                        <label className={`cursor-pointer flex items-center justify-center border rounded-xl p-4 gap-4 ${selected === 'installments' ? 'border-violet-600 bg-green-50' : 'border-gray-300'}`}>
                                            <PowerBatchCalendar />
                                            <div className="flex items-center justify-between w-full">
                                                <div>
                                                    <p className="text-base font-semibold text-[#1B2124]">Pay Fee in Easy Instalments</p>
                                                    <p className="text-[12px] text-[#757575]">Book your seat now, pay remaining fee in instalments</p>
                                                </div>
                                                <div className="text-right">
                                                    <p className="text-base font-semibold text-[#1B2124]">₹ {partPayment?.feeDetails?.[0]?.gstPrice}</p>
                                                    <p className="text-[12px] text-[#757575]">seat booking amount</p>
                                                    {partPayment?.instalmentDetails?.length > 0 && <p className="text-sm text-[#5a4bda] mt-1 underline cursor-pointer" onClick={() => handleInstallmentOpen(fullPayment, selected)}>+{partPayment?.instalmentDetails?.length} instalments</p>}
                                                </div>
                                            </div>
                                            <RadioButton
                                                variant='primary'
                                                name="payment"
                                                value="installments"
                                                checked={selected === 'installments'}
                                                onChange={() => setSelected('installments')}
                                            />
                                        </label>
                                    </div>

                                    <div>
                                        <p className="text-[#757575] text-sm font-medium mb-3">Additional Method(s)</p>

                                        <label className={`cursor-pointer flex items-center justify-center border rounded-xl p-4 gap-4 ${selected === 'full' ? 'border-violet-600 bg-yellow-50' : 'border-gray-300'}`}>
                                            <PowerBatchPayment />

                                            <div className="flex items-center justify-between w-full">
                                                <div>
                                                    <p className="text-base font-semibold text-[#1B2124]">Pay the Full Course Fee</p>
                                                    <p className="text-[12px] text-[#757575]">Save big on full payment</p>
                                                </div>
                                                <div className="text-right">
                                                    <p className="text-base font-semibold text-[#1B2124]">₹{fullPayment?.total}</p>
                                                    <p className="text-[12px] text-[#757575]">Full Course Fee</p>
                                                </div>
                                            </div>
                                            <RadioButton
                                                variant='primary'
                                                name="payment"
                                                value="full"
                                                checked={selected === 'full'}
                                                onChange={() => setSelected('full')}
                                            />
                                        </label>
                                    </div>
                                    <div className='mt-4'>
                                        <Button
                                            variant='primary'
                                            onClick={() => handlePowerPaymentClose(fullPayment, selected)}
                                            fullWidth
                                        >
                                            Proceed
                                        </Button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>

    );
}
